import type { Theme } from "@mui/material/styles";

export const getToastAlertSx = (theme: Theme) => ({
  backgroundColor: theme.palette.background.default,
  boxShadow: "0px 10px 48px -16px #0000001F",
});

export const getTitleStyle = (theme: Theme) => ({
  color: theme.palette.text.primary,
});

export const getDescriptionStyle = (theme: Theme) => ({
  color: theme.palette.text.primary,
  whiteSpace: "pre-line",
});

export const closeIconSx = {
  marginTop: "-4px",
};

export const toastIconStyle = {
  marginTop: "-4px",
};

export const closeIconSize = {
  width: "16px",
  height: "16px",
};
